/**
 * Created by tofael on 3/22/17.
 */

import { combineReducers } from 'redux';

import user from './user';
import application from'./application'

export default combineReducers({
  user,
  application
});


// WEBPACK FOOTER //
// ./src/reducers/index.js